export default "__VITE_ASSET__UvunnKO1__";